import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { ScreenContainer } from '../../projects/components/styled-project-components';
import { CallsheetTab } from '../components/callsheet-tab';
import { ShootingDayHeader } from '../components/shooting-day-screen.header';
import { StepDrawer } from '../../projects/components/step.drawer';
import { uiStore } from '../../../core/stores/ui-store';
import { PropertiesPanel } from '../../properties/components/properties-panel';
import styles from './shooting-day-screen.module.scss';

import type { Project, Step } from '../../../app/entities';

interface ShootingDayScreenProps {
  project: Project;
  step: Step;
}

export const ShootingDayScreen: React.FC<ShootingDayScreenProps> = observer(({ project, step }) => {
  useEffect(() => {
    return () => uiStore.closeTaskPanel();
  }, []);

  return (
    <React.Fragment>
      <ShootingDayHeader step={step} project={project} />

      <StepDrawer step={step} />

      <ScreenContainer>
        <CallsheetTab project={project} step={step} />
      </ScreenContainer>

      {uiStore.isPropertiesPanelOpen && !!uiStore.propertiesPanelTargetId && (
        <div className={styles.Drawer}>
          <PropertiesPanel targetId={step.resource._id} view={step.resource} />
        </div>
      )}
    </React.Fragment>
  );
});
